module.exports = __webpack_public_path__ + "img/license_status_fail.2214c254.svg";